export default {
  placeholder: 'Indifferent',
  selected: 'selected',
  selectedPlural: 'selected',
};
